<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconOpenInNew_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.967 2h9.174a.86.86 0 0 1 .859.86v9.174a.86.86 0 0 1-1.675.274l-1.7-5.062-6.473 6.472a1.323 1.323 0 0 1-1.87-1.87l6.472-6.473-5.062-1.701A.859.859 0 0 1 11.967 2ZM3 2h5a1 1 0 0 1 0 2H4v16h16v-4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z"
        clip-rule="evenodd"
    />
</svg>
